import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _isNil from 'lodash/isNil';
import { makeStyles } from '@material-ui/core/styles';
import { fallbackImage } from 'utils/stringUtils';

const useStyles = makeStyles({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  positionOne: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '50%',
    width: '50%',
    overflow: 'hidden',
  },
  positionTwo: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '50%',
    width: '50%',
    overflow: 'hidden',
  },
  positionThree: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '50%',
    width: '50%',
    overflow: 'hidden',
  },
  positionFour: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: '50%',
    width: '50%',
    overflow: 'hidden',
  },
  imageWrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blurredBackground: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    filter: 'blur(5px)',
    '-webkit-filter': 'blur(5px)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  image: {
    zIndex: 1,
    height: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  singleImage: {
    zIndex: 1,
    height: 100,
    maxWidth: '100%',
    objectFit: 'contain',
  },
  grayscale: {
    filter: 'grayscale(1)',
  },
});

function ListImage({ images, grayscale }) {
  const classes = useStyles();

  let valid = false;
  if (Array.isArray(images)) {
    if (images.length > 0) valid = true;
  } else if (!_isNil(images)) valid = true;

  if (!valid)
    return (
      <img
        src={fallbackImage}
        className={classes.singleImage}
        alt="Not available"
      />
    );

  const shouldDrawFourImages = Array.isArray(images) && images.length >= 4;
  return (
    <div className={classes.container}>
      {shouldDrawFourImages ? (
        <>
          <div className={classes.positionOne}>
            <div className={classes.imageWrapper}>
              <div
                className={classes.blurredBackground}
                style={{
                  backgroundImage: `url(${images[0]})`,
                }}
              />
              <img
                src={images[0]}
                onError={e => {
                  e.target.src = fallbackImage;
                }}
                className={_classNames(classes.image, {
                  [classes.grayscale]: grayscale,
                })}
                alt="First resource of list"
              />
            </div>
          </div>
          <div className={classes.positionTwo}>
            <div className={classes.imageWrapper}>
              <div
                className={classes.blurredBackground}
                style={{
                  backgroundImage: `url(${images[1]})`,
                }}
              />
              <img
                src={images[1]}
                onError={e => {
                  e.target.src = fallbackImage;
                }}
                className={_classNames(classes.image, {
                  [classes.grayscale]: grayscale,
                })}
                alt="Second resource of list"
              />
            </div>
          </div>
          <div className={classes.positionThree}>
            <div className={classes.imageWrapper}>
              <div
                className={classes.blurredBackground}
                style={{
                  backgroundImage: `url(${images[2]})`,
                }}
              />
              <img
                src={images[2]}
                onError={e => {
                  e.target.src = fallbackImage;
                }}
                className={_classNames(classes.image, {
                  [classes.grayscale]: grayscale,
                })}
                alt="Third resource of list"
              />
            </div>
          </div>
          <div className={classes.positionFour}>
            <div className={classes.imageWrapper}>
              <div
                className={classes.blurredBackground}
                style={{
                  backgroundImage: `url(${images[3]})`,
                }}
              />
              <img
                src={images[3]}
                onError={e => {
                  e.target.src = fallbackImage;
                }}
                className={_classNames(classes.image, {
                  [classes.grayscale]: grayscale,
                })}
                alt="Fourth resource of list"
              />
            </div>
          </div>
        </>
      ) : (
        <div className={classes.imageWrapper}>
          <div
            className={classes.blurredBackground}
            style={{
              backgroundImage: `url(${images[0]})`,
            }}
          />
          <img
            src={images[0]}
            onError={e => {
              e.target.src = fallbackImage;
            }}
            className={_classNames(classes.singleImage, {
              [classes.grayscale]: grayscale,
            })}
            alt="List"
          />
        </div>
      )}
    </div>
  );
}

ListImage.propTypes = {
  images: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  grayscale: PropTypes.bool,
};

export default ListImage;
